import { Accordion, AccordionSummary, AccordionDetails, Typography, Alert, Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";

const CustomAccordion = ({ expanded, panel, handleChange, title, csvHeaders, headers, children }) => {
    return(
        <Accordion TransitionProps={{ unmountOnExit: true }} expanded={ expanded === panel } onChange={handleChange(panel)}>
            <AccordionSummary expandIcon={<ExpandMore />} aria-controls={`${panel}`.concat('bh-content')} id={`${panel}`.concat('bh-header')}>
                <Typography sx={{ width: '33%', flexShrink: 0 }}>{title}</Typography>
                <Typography sx={{ color: 'text.secondary' }}>Ver los campos que debe contener el archivo CSV</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Alert severity="warning" sx={{ fontWeight: 'bolder' }}>{csvHeaders}</Alert>
                <Table>
                    <TableHead>
                        <TableRow>
                            {headers.map((h, i) => <TableCell key={i}> {h} </TableCell>)}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {children}
                    </TableBody>
                </Table>
            </AccordionDetails>
        </Accordion>
    )
}

export default CustomAccordion;